export default () => {
  const sampleLink = document.querySelector('.js-open-sample-tab')
  const sampleTab = document.getElementById('proefstaaltjes')
  if (!sampleLink || !sampleTab) return

  sampleLink.addEventListener('click', e => {
    e.preventDefault()
    const trigger = sampleTab.querySelector('.js-toggle-trigger')
    const target = sampleTab.querySelector('.js-toggle-panel')

    const y = target.getBoundingClientRect().top - 120

    trigger.classList.add('active')
    target.classList.add('active')

    window.scrollTo({ top: y, behavior: 'smooth' })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/OpenSampleTab.js